import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Fade from '@mui/material/Fade';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Typography from 'Components/UI/Typography';
import FacetParticleIcon from 'Views/Onboarding/Components/ParticleIcon';
import FacetFacNegative from 'Icons/Brand/FacetFacNegative';

import { FACET_PARTICLE_CLIP_PATHS } from 'Views/Onboarding/consts';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    marginTop: '15vh',
  },
  title: {
    marginBottom: theme.spacing(4),
    fontSize: 32,
  },
  smallerTitle: {
    fontSize: 26,
  },
  message: {
    lineHeight: 1.75,
  },
  particleIcon: {
    marginBottom: theme.spacing(4),
  },
  iconWrapper: {
    width: 150,
    height: 150,
    background: theme.palette.facet.accentBlue20,
    clipPath: FACET_PARTICLE_CLIP_PATHS.lessRounded,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  facIcon: {
    height: 60,
    width: '100%',
    marginBottom: theme.spacing(4),
  },
});

const AccountSetupSection = ({
  classes,
  className,
  icon,
  title,
  titleVariant,
  messages,
  showFacetIcon,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  if (!resource) return null;
  const messagesToShow = Boolean(messages && messages.length >= 1);

  return (
    <div className={classNames(classes.root, className)}>


      {/* ----- Facet 'Fac' Icon ----- */}
      {showFacetIcon && (
        <Fade in timeout={400}>
          <FacetFacNegative
            className={classes.facIcon}
          />
        </Fade>)
      }


      {/* ----- Particle (polygon) Icon ----- */}
      {icon && (
        <Fade in timeout={400}>
          <FacetParticleIcon
            className={classes.particleIcon}
            icon={icon}
          />
        </Fade>)
      }

      {/* ----- Title / Message(s) ----- */}
      <Fade in timeout={800}>
        <div>
          <Typography
            variant={titleVariant}
            color="primary"
            className={classNames(classes.title, { [classes.smallerTitle]: titleVariant === 'h2' })}
            weight="bold"
            align="center"
          >
            {title}
          </Typography>

          {messagesToShow && messages.map((message) => {
            return (
              <Typography
                key={message}
                className={classes.message}
                color="primaryGray2"
                variant="h4"
                weight="book"
                align="center"
                paragraph
              >
                {message}
              </Typography>);
          })}
        </div>
      </Fade>
    </div>
  );
};

AccountSetupSection.defaultProps = {
  className: '',
  titleVariant: 'h1',
  messages: [],
  icon: null,
  showFacetIcon: false,
};

AccountSetupSection.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  messages: PropTypes.array,
  icon: PropTypes.node,
  showFacetIcon: PropTypes.bool,
};

export default withStyles(styles)(AccountSetupSection);
